export const RoleConfig = (pageName, action, role) => {
  const roleJson = [
    {
      pageName: "Home",
      complianceScore: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "SHF Admin",
        "Config Admin",
      ],
      cloudAccounts: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "License Group Owner",
        "License Viewer",
        "SIRAR User",
        "SIRAR Reviewer",
        "Auditor",
        "CCI Admin",
        "SHF Admin",
        "LM Admin",
        "SIRAR Admin",
        "Config Admin",
      ],
    },
    {
      pageName: "CMDB",
      add: ["Operation", "Group Head"],
      edit: ["Operation"],
      delete: ["Operation", "Group Head"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
      ],
      configure: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "AOR Details",
      add: ["Operation", "Finance Analyst", "Application Owner", "CCI Admin"],
      edit: ["Operation", "Finance Analyst", "Application Owner", "CCI Admin"],
      delete: ["Operation", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "Budget Details",
      add: ["Operation", "Finance Analyst", "Application Owner", "CCI Admin"],
      edit: ["Operation", "Finance Analyst", "Application Owner", "CCI Admin"],
      delete: ["Operation"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "Go Live & Alert Configuration",
      edit: ["Operation", "Finance Analyst", "Application Owner", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "Master List - Cloud Accounts",
      add: ["Operation", "CCI Admin"],
      edit: ["Operation", "CCI Admin"],
      delete: ["Operation", "CCI Admin"],
      import: ["Operation", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "CCI Admin",
      ],
    },
    {
      pageName: "Cloud Accounts",
      add: ["Operation", "Application Owner", "CCI Admin"],
      delete: ["Operation", "Application Owner", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "CCI Admin",
      ],
    },
    {
      pageName: "Devices",
      add: ["Operation", "Application Owner"],
      delete: ["Operation", "Application Owner"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
      ],
    },
    {
      pageName: "USD to SGD Currency Conversion",
      add: ["Operation", "CCI Admin"],
      edit: ["Operation", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "Costing Calculation",
      edit: ["Operation", "CCI Admin"],
    },
    {
      pageName: "User Management",
      add: ["Operation", "Config Admin"],
      edit: ["Operation", "Config Admin"],
      delete: ["Operation", "Config Admin"],
      status: ["Operation", "Config Admin"],
      view: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Config Admin",
      ],
    },
    {
      pageName: "Role Mapping",
      edit: ["Operation", "Config Admin"],
      view: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Config Admin",
        "SIRAR Admin",
        "LM Admin",
        "CCI Admin",
        "SHF Admin",
        "PMO",
        "PM",
        "Invoice Team",
      ],
    },
    {
      pageName: "Ciso Insights",
      "approve/reject": ["Ciso"],
      view: [
        "Ciso",
        "Operation",
        "Group Head",
        "Division Head",
        "Business Owner",
        "Compliance Lead",
      ],
    },
    {
      pageName: "Security Hub Findings",
      request: ["Operation", "Compliance Lead", "SHF Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "SHF Admin",
      ],
    },
    {
      pageName: "Audit Log",
      download: ["Operation", "Config Admin"],
      view: ["Operation", "Division Head", "Application Owner", "Config Admin"],
    },
    {
      pageName: "Scedulars - Data Import",
      add: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      edit: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      delete: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      status: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      pageName: "Scedulars - Email",
      add: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      edit: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      delete: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      pageName: "Email Schedule Configuration",
      add: ["Budget Admin", "PMO"],
      edit: ["Budget Admin", "PMO"],
      delete: ["Budget Admin", "PMO"],
      view: ["Budget Admin", "PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      pageName: "Tools",
      add: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      edit: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      delete: ["Operation", "CCI Admin", "SHF Admin", "Config Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      pageName: "Business Info",
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "PMO",
        "PM",
        "Invoice Team",
      ],
      RollAlocation: [
        "Operation",
        "SIRAR Admin",
        "Config Admin",
        "Budget Admin",
      ],
    },
    {
      pageName: "Software List",
      add: ["Operation", "LM Admin"],
      edit: ["Operation", "LM Admin"],
      delete: ["Operation", "LM Admin"],
      exportCSV: ["Operation", "LM Admin"],
      // view: ["Operation", "Group Head", "Department Head", "Division Head", "Application Owner", "Business Owner"],
    },
    {
      pageName: "Software Group",
      add: ["Operation", "License Group Owner", "LM Admin"],
      edit: ["Operation", "License Group Owner", "LM Admin"],
      delete: ["Operation", "License Group Owner", "LM Admin"],
      // view: ["Operation", "Group Head", "Department Head", "Division Head", "Application Owner", "Business Owner"],
    },
    {
      pageName: "License Management",
      add: ["Operation", "License Group Owner", "LM Admin"],
      edit: ["Operation", "License Group Owner", "LM Admin"],
      delete: ["Operation", "License Group Owner", "LM Admin"],
      attest_Validate: ["Division Head"],
      consumed_edit: ["Operation", "License Group Owner", "LM Admin"],
      summary_details: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "LM Admin",
      ],
    },
    {
      pageName: "ESX",
      add: ["Operation", "License Group Owner", "LM Admin"],
      edit: ["Operation", "License Group Owner", "LM Admin"],
      delete: ["Operation", "License Group Owner", "LM Admin"],
      // view: ["Operation", "Group Head", "Department Head", "Division Head", "Application Owner", "Business Owner"],
    },
    {
      pageName: "Sirar",
      Request: ["Operation", "SIRAR User", "SIRAR Admin"],
      view: ["Operation", "SIRAR User", "SIRAR Admin"],
    },
    {
      pageName: "Log Approver Insights",
      "approve/reject": ["Division Head"],
    },
    {
      pageName: "Log Reviewer Insights",
      "approve/reject": ["Operation", "SIRAR Reviewer", "SIRAR Admin"],
    },
    {
      pageName: "Change Request Mapping",
      view: ["Operation", "SIRAR User"],
    },
    {
      pageName: "Marketplace Cost",
      add: ["Operation", "Finance Admin", "CCI Admin"],
      edit: ["Operation", "Finance Admin", "CCI Admin"],
      delete: ["Operation", "Finance Admin", "CCI Admin"],
    },
    {
      pageName: "GCC Discount",
      edit: ["Operation", "CCI Admin"],
      delete: ["Operation", "CCI Admin"],
      view: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Finance Admin",
        "Finance Analyst",
        "CCI Admin",
      ],
    },
    {
      pageName: "Container Cost",
      infraOverview: ["Operation", "Finance Admin", "CCI Admin"],
    },
    {
      pageName: "PMO Approval",
      approve: ["PMO"],
      reject: ["PMO"],
      view: ["PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      pageName: "Budget Management",
      upload: ["PMO"],
    },
    {
      pageName: "Invoice Management",
      view: ["PM", "PMO", "Invoice Team", "Division Head"],
      upload: ["PMO", "Invoice Team"],
    },
    {
      pageName: "Budget Configuration",
      upload: ["Budget Admin", "PMO"],
      add: ["Budget Admin", "PM"],
      edit: ["Budget Admin", "PM"],
      delete: ["Budget Admin", "PM"],
      status: ["Budget Admin", "PM"],
      view: ["Budget Admin", "PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      pageName: "CSD Configuration",
      add: ["Budget Admin"],
      edit: ["Budget Admin"],
      delete: ["Budget Admin"],
      status: ["Budget Admin"],
    },
    {
      pageName: "Supplier Configuration",
      upload: ["Budget Admin", "PMO"],
      add: ["Budget Admin", "PMO"],
      delete: ["Budget Admin", "PMO"],
    },
    {
      pageName: "Cost Comparison",
      upload: ["Operation"],
    },
  ];

  // const page = roleJson.find(item => item.pageName === pageName);
  // if (page && page[action]) {
  //     return page[action].includes(role);
  // }
  const page = roleJson.find((item) => item.pageName === pageName);
  if (page && page[action]) {
    if (Array.isArray(role)) {
      return role.some((r) => page[action].includes(r));
    } else {
      return page[action].includes(role);
    }
  }
  return false;
};
export const filterDataHeader = (
  dataheader,
  headerName,
  moduleName,
  userRole,
  permissions,
) => {
  return dataheader.filter((header) => {
    if (header.Header === headerName) {
      return permissions.some((permission) =>
        RoleConfig(moduleName, permission, userRole),
      );
    }
    return true;
  });
};

export const navigationPrevilages = (routepath, userRole) => {
  const allowedRoles = [
    // Home
    {
      path: "home",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "License Group Owner",
        "License Viewer",
        "SIRAR User",
        "SIRAR Reviewer",
        "Auditor",
        "LM Admin",
        "SIRAR Admin",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    { path: "home/BusinessInfoConfig", roles: ["Operation"] },
    {
      path: "home/:appName/DeviceConfig",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "License Group Owner",
        "License Viewer",
      ],
    },
    {
      path: "home/:appName/accountIDs",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "License Group Owner",
        "License Viewer",
        "CCI Admin",
        "Config Admin",
        "LM Admin",
        "SHF Admin",
        "SIRAR Admin",
      ],
    },

    // Compliance
    {
      path: "gnc/compliance/securityHub/securityHubFindingsLandings",
      roles: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "SHF Admin",
      ],
    },
    {
      path: "gnc/compliance/CloudScapeFindings",
      roles: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Ciso",
        "Soc Lead",
        "Compliance Lead",
        "SHF Admin",
      ],
    },

    // Ciso Insights
    {
      path: "gnc/CISOInsights/securityHubFindings",
      roles: [
        "Ciso",
        "Operation",
        "Group Head",
        "Division Head",
        "Business Owner",
        "Compliance Lead",
        "SHF Admin",
      ],
    },
    {
      path: "gnc/CISOInsights/CloudScapeFindings",
      roles: [
        "Ciso",
        "Operation",
        "Group Head",
        "Division Head",
        "Business Owner",
        "Compliance Lead",
        "SHF Admin",
      ],
    },

    // Cloud Cost Insights
    {
      path: "costInsights/cloudCost",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/containerCost",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/containerCost/CostOverview",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/cloudCost/CostOverview",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/marketplacecost",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/marketplacecost/CostOverview",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/CostOverviewPlatform/Overview",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/CostOverviewPlatform/Summary",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "costInsights/CostOverviewPlatform/CostComparison",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },

    // License Management
    {
      path: "softwareLicenseManagement/Summary",
      roles: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "License Viewer",
        "LM Admin",
      ],
    },
    {
      path: "/softwareLicenseManagement/licenseManagement/licenseconfigpage",
      roles: ["Operation", "LM Admin"],
    },
    {
      path: "softwareLicenseManagement/licenseManagement",
      roles: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "License Viewer",
        "LM Admin",
      ],
    },
    {
      path: "softwareLicenseManagement/ESXGroup",
      roles: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "License Viewer",
        "LM Admin",
      ],
    },

    //SIRAR Management
    {
      path: "Sirar",
      roles: [
        "Operation",
        "Division Head",
        "SIRAR User",
        "SIRAR Reviewer",
        "Auditor",
        "SIRAR Admin",
      ],
    },
    {
      path: "Sirar/logApproverInsights",
      roles: [
        "Operation",
        "Division Head",
        "SIRAR User",
        "SIRAR Reviewer",
        "Auditor",
        "SIRAR Admin",
      ],
    },
    {
      path: "Sirar/logReviewerInsights",
      roles: [
        "Operation",
        "Division Head",
        "SIRAR Reviewer",
        "Auditor",
        "SIRAR Admin",
      ],
    },
    // { path: "Sirar/changeRequestMapping", roles: ["Operation","SIRAR User"] },

    //Budget Module
    {
      path: "financeAndBudget/overview",
      roles: ["Division Head", "Budget Admin", "PMO", "PM", "Invoice Team"],
    },
    {
      path: "financeAndBudget/budgetManagement",
      roles: ["PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/config",
      roles: ["Budget Admin", "PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/subconManagement",
      roles: ["PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/subconManagement/createsubcon",
      roles: ["PMO", "PM", "Invoice Team"],
    },
    {
      path: "financeAndBudget/subconManagement/updatesubcon",
      roles: ["PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/invoiceManagement",
      roles: ["PM", "PMO", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/pmoApproval",
      roles: ["PMO", "PM", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/config",
      roles: ["PM", "PMO", "Budget Admin", "Invoice Team", "Division Head"],
    },
    {
      path: "financeAndBudget/config/others",
      roles: ["PMO", "PM", "Budget Admin", "Invoice Team", "Division Head"],
    },

    // CMDB Master pages
    {
      path: "configuration/cmdb/BusinessInfoConfig",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "LM Admin",
        "SIRAR Admin",
        "SHF Admin",
        "CCI Admin",
        "Config Admin",
        "Budget Admin",
        "PMO",
        "PM",
        "Invoice Team",
      ],
    },
    {
      path: "configuration/cmdb/BusinessInfoConfig/roleAllocation",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Budget Admin",
        "PMO",
        "PM",
        "Invoice Team",
      ],
    },
    {
      path: "configuration/cmdb/masterlist/UserInfoConfig",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
      ],
    },
    {
      path: "configuration/cmdb/masterlist/Devices",
      roles: ["Operation", "Application Owner", "LM Admin", "Config Admin"],
    },
    {
      path: "softwareLicenseManagement/softwareGroup",
      roles: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "License Viewer",
        "LM Admin",
      ],
    },
    {
      path: "configuration/cmdb/masterlist/cloudaccount",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "LM Admin",
        "SIRAR Admin",
        "Config Admin",
      ],
    },
    {
      path: "softwareLicenseManagement/SoftwareList",
      roles: [
        "Operation",
        "Division Head",
        "License Group Owner",
        "License Viewer",
        "LM Admin",
      ],
    },

    // CMDB main and child Pages
    {
      path: "configuration/cmdb",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "LM Admin",
        "SIRAR Admin",
        "Config Admin",
      ],
    },
    // { path: "configuration/cmdb/:appName/DeviceConfig", roles: ["Operation", "Ciso", "Compliance Lead", "Finance Admin", "Finance Analyst", "Soc Lead", "Group Head", "Department Head", "Division Head", "Application Owner", "Business Owner"] },
    {
      path: "configuration/cmdb/:appName/accountIDs",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SIRAR Admin",
        "LM Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      path: "configuration/cmdb/applicationConfiguration",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "configuration/cmdb/Devices/licenseconfigpage",
      roles: ["Operation", "Application Owner"],
    },

    // Settings
    {
      path: "configuration/settings/CloudCost",
      roles: [
        "Operation",
        "Finance Admin",
        "Finance Analyst",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
      ],
    },
    {
      path: "configuration/settings/Schedulers",
      roles: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      path: "configuration/settings/tools",
      roles: [
        "Operation",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    {
      path: "configuration/settings/PIIDataConfiguration",
      roles: ["Operation"],
    },

    // administration
    {
      path: "configuration/administration/directoryConfiguration",
      roles: ["Operation", "Config Admin"],
    },
    {
      path: "configuration/administration/smtpConfig",
      roles: ["Operation", "Config Admin"],
    },
    {
      path: "configuration/administration/licenseConfig",
      roles: ["Operation", "Config Admin"],
    },
    {
      path: "configuration/administration/userManagement",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "License Group Owner",
        "License Viewer",
        "Config Admin",
        "SIRAR Admin",
        "LM Admin",
        "CCI Admin",
        "SHF Admin",
      ],
    },
    {
      path: "configuration/administration/loggingConfig",
      roles: ["Operation"],
    },
    { path: "configuration/auditLog", roles: ["Operation", "Config Admin"] },
    {
      path: "/configuration/administration/userManagement/rolemapping",
      roles: [
        "Operation",
        "Ciso",
        "Compliance Lead",
        "Finance Admin",
        "Finance Analyst",
        "Soc Lead",
        "Group Head",
        "Department Head",
        "Division Head",
        "Application Owner",
        "Business Owner",
        "Config Admin",
        "SIRAR Admin",
        "LM Admin",
        "CCI Admin",
        "SHF Admin",
        "PMO",
        "PM",
        "Invoice Team",
      ],
    },
    {
      path: "configuration/administration/loggingConfig",
      roles: ["Operation"],
    },
    {
      path: "configuration/usersession",
      roles: [
        "Operation",
        "LM Admin",
        "SIRAR Admin",
        "CCI Admin",
        "SHF Admin",
        "Config Admin",
      ],
    },
    { path: "configuration/auditLog", roles: ["Operation", "Config Admin"] },
  ];

  const allowedRoute = allowedRoles.find((route) => route.path === routepath);
  const hasAccess =
    userRole === ""
      ? true
      : allowedRoute
        ? Array.isArray(userRole)
          ? userRole.some((role) => allowedRoute.roles.includes(role))
          : allowedRoute.roles.includes(userRole)
        : false;
  return hasAccess;
};

export const IsShowLicenseManagement = (Path, isShowLM) => {
  const LicenseManagementDashBoard = [
    "softwareLicenseManagement/Summary",
    "softwareLicenseManagement/licenseManagement",
    "/softwareLicenseManagement/licenseManagement/licenseconfigpage",
    "configuration/cmdb/Devices/licenseconfigpage",
    "softwareLicenseManagement/softwareGroup",
    "softwareLicenseManagement/SoftwareList",
    "softwareLicenseManagement/ESXGroup",
    "configuration/cmdb/masterlist/Devices",
    // "configuration/cmdb/:appName/DeviceConfig",
  ];

  return isShowLM === ""
    ? false
    : LicenseManagementDashBoard.includes(Path) && !isShowLM;
};

export const IsShowSirar = (Path, isShowSirar) => {
  const SirarDashBoard = [
    "Sirar",
    "Sirar/logApproverInsights",
    // "Sirar/logReviewerInsights"
  ];

  return isShowSirar === ""
    ? false
    : SirarDashBoard.includes(Path) && !isShowSirar;
};
export const IsShowContainerCost = (Path, IsShowContainerCost) => {
  const ContainerCostDashBoard = [
    "costInsights/containerCost",
    "costInsights/containerCost/CostOverview",
  ];

  return IsShowContainerCost === ""
    ? false
    : ContainerCostDashBoard.includes(Path) && !IsShowContainerCost;
};

export const IsShowBM = (Path, isShowBM) => {
  return isShowBM === ""
    ? false
    : Path.startsWith("financeAndBudget") && !isShowBM;
};

export const navigationPanelConfig = [
  //firstChildNavigation
  {
    pagename: "home",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "License Group Owner",
      "License Viewer",
      "SIRAR User",
      "SIRAR Reviewer",
      "Auditor",
      "LM Admin",
      "SIRAR Admin",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
    ],
  },
  {
    pagename: "gnc",
    roles: [
      "Operation",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "Ciso",
      "Soc Lead",
      "Compliance Lead",
      "SHF Admin",
    ],
  },
  {
    pagename: "configuration",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "License Group Owner",
      "License Viewer",
      "LM Admin",
      "SIRAR Admin",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
      "Budget Admin",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
  {
    pagename: "Business Info",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "LM Admin",
      "SIRAR Admin",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
      "Budget Admin",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
  { pagename: "Server", roles: ["Operation"] },
  {
    pagename: "Account IDs",
    roles: ["Operation", "CCI Admin", "Config Admin"],
  },
  {
    pagename: "Compliance",
    roles: [
      "Operation",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "Ciso",
      "Soc Lead",
      "Compliance Lead",
      "SHF Admin",
    ],
  },
  {
    pagename: "Sirar",
    roles: [
      "Operation",
      "Division Head",
      "SIRAR User",
      "SIRAR Reviewer",
      "Auditor",
      "SIRAR Admin",
    ],
  },
  {
    pagename: "Log Approver Insights",
    roles: [
      "Operation",
      "Division Head",
      "SIRAR User",
      "Auditor",
      "SIRAR Reviewer",
      "SIRAR Admin",
    ],
  },
  {
    pagename: "Log Reviewer Insights",
    roles: [
      "Operation",
      "Division Head",
      "SIRAR Reviewer",
      "Auditor",
      "SIRAR Admin",
    ],
  },
  { pagename: "Change Request Mapping", roles: ["Operation", "SIRAR User"] },
  {
    pagename: "Ciso Insights",
    roles: [
      "Ciso",
      "Operation",
      "Group Head",
      "Division Head",
      "Business Owner",
      "Compliance Lead",
      "SHF Admin",
    ],
  },
  {
    pagename: "costInsights",
    roles: [
      "Operation",
      "Finance Admin",
      "Finance Analyst",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
    ],
  },
  {
    pagename: "financeAndBudget", 
    roles: ["Division Head", "Budget Admin", "PMO", "PM", "Invoice Team"],
  },
  {
    pagename: "Budget Management",
    roles: ["PMO", "PM", "Invoice Team", "Division Head"],
  },
  {
    pagename: "Supplier Contract Management",
    roles: ["PMO", "PM", "Invoice Team", "Division Head"],
  },
  {
    pagename: "PMO Approval",
    roles: ["PMO", "PM", "Invoice Team", "Division Head"],
  },
  {
    pagename: "Invoice Management",
    roles: ["PM", "PMO", "Invoice Team", "Division Head"],
  },
  {
    pagename: "Others",
    roles: ["PMO", "PM", "Budget Admin", "Invoice Team", "Division Head"],
  },
  {
    pagename: "License Management",
    roles: [
      "Operation",
      "Division Head",
      "License Group Owner",
      "License Viewer",
      ,
      "LM Admin",
    ],
  },
  {
    pagename: "softwareLicenseManagement",
    roles: [
      "Operation",
      "Division Head",
      "License Group Owner",
      "License Viewer",
      "LM Admin",
    ],
  },
  {
    pagename: "CMDB",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "LM Admin",
      "CCI Admin",
      "SHF Admin",
      "SIRAR Admin",
      "Config Admin",
      "Budget Admin",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
  {
    pagename: "Settings",
    roles: [
      "Operation",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "Finance Admin",
      "Finance Analyst",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
    ],
  },
  {
    pagename: "administration",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "License Group Owner",
      "License Viewer",
      "Config Admin",
      "LM Admin",
      "SHF Admin",
      "SIRAR Admin",
      "CCI Admin",
    ],
  },
  {
    pagename: "Administration",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "License Group Owner",
      "License Viewer",
      "Config Admin",
      "LM Admin",
      "SHF Admin",
      "SIRAR Admin",
      "CCI Admin",
    ],
  },
  {
    pagename: "UserSession",
    roles: [
      "Operation",
      "LM Admin",
      "SIRAR Admin",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
    ],
  },
  { pagename: "AuditLog", roles: ["Operation", "Config Admin"] },

  //secondChildNavigation
  {
    pagename: "Configuration",
    roles: ["Budget Admin", "PMO", "PM", "Invoice Team", "Division Head"],
  },
  {
    pagename: "Business Info",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
      "SIRAR Admin",
      "SHF Admin",
      "LM Admin",
      "Budget Admin",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
  {
    pagename: "Role Allocation",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "Budget Admin",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
  {
    pagename: "Users",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
    ],
  },
  {
    pagename: "Devices",
    roles: ["Operation", "Application Owner", "LM Admin", "Config Admin"],
  },
  {
    pagename: "Cloud Accounts",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
      "SHF Admin",
      "LM Admin",
      "SIRAR Admin",
      "Config Admin",
    ],
  },
  { pagename: "Server", roles: ["Operation"] },
  {
    pagename: "Account IDs",
    roles: ["Operation", "CCI Admin", "Config Admin"],
  },
  {
    pagename: "Software Group",
    roles: [
      "Operation",
      "Division Head",
      "License Group Owner",
      "License Viewer",
      "LM Admin",
    ],
  },
  {
    pagename: "Software List",
    roles: [
      "Operation",
      "Division Head",
      "License Group Owner",
      "License Viewer",
      "LM Admin",
    ],
  },
  { pagename: "Application Configuration", roles: ["Operation"] },
  {
    pagename: "Cloud Cost",
    roles: [
      "Operation",
      "Finance Admin",
      "Finance Analyst",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
    ],
  },
  {
    pagename: "Schedulers",
    roles: [
      "Operation",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
    ],
  },
  {
    pagename: "Tools",
    roles: [
      "Operation",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "CCI Admin",
      "SHF Admin",
      "Config Admin",
    ],
  },
  { pagename: "PII Data Configuration", roles: ["Operation"] },
  { pagename: "Directory Configuration", roles: ["Operation", "Config Admin"] },
  { pagename: "SmtpConfig", roles: ["Operation", "Config Admin"] },
  { pagename: "LicenseConfig", roles: ["Operation", "Config Admin"] },
  {
    pagename: "UserManagement",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "License Group Owner",
      "License Viewer",
      "Config Admin",
      "LM Admin",
      "SHF Admin",
      "SIRAR Admin",
      "CCI Admin",
    ],
  },
  { pagename: "LoggingConfig", roles: ["Operation"] },
  {
    pagename: "RoleMapping",
    roles: [
      "Operation",
      "Ciso",
      "Compliance Lead",
      "Finance Admin",
      "Finance Analyst",
      "Soc Lead",
      "Group Head",
      "Department Head",
      "Division Head",
      "Application Owner",
      "Business Owner",
      "PMO",
      "PM",
      "Invoice Team",
    ],
  },
];
export const hasAccessToPage = (pagename, userRole, config) => {
  const pageAccess = config.find((page) => page.pagename === pagename);
  const hasAccess = pageAccess
    ? Array.isArray(userRole)
      ? userRole.some((role) => pageAccess.roles.includes(role))
      : pageAccess.roles.includes(userRole)
    : true;
  return hasAccess;
};
